module.exports = __webpack_public_path__ + "static/media/laddersSlides.c00d14a3.png";